import store from "../store";

export const navData = () => {
  const primaryLinks = [
    {
      to: "#Landing",
      title: "Welcome",
      offset: -100,
      id: 1,
      trackingTitle: "Welcome",
      anchors: [
        {
          anchor: "#header",
          title: "Welcome",
        },
      ],
    },
    {
      to: "#Flex",
      title: "Season Membership",
      offset: -100,
      id: 2,
      trackingTitle: "Season Membership",
      anchors: [
        {
          anchor: "#header",
          title: "Season Membership",
        },
      ],
    },
    {
      to: "#Traditional",
      title: "Traditional Membership",
      offset: -100,
      id: 3,
      trackingTitle: "Traditional Membership",
      anchors: [
        {
          anchor: "#header",
          title: "Traditional Membership",
        },
      ],
    },
    {
      to: "#Flexible",
      title: "Flexible Membership",
      offset: -100,
      id: 4,
      trackingTitle: "Flexible Membership",
      anchors: [
        {
          anchor: "#header",
          title: "Flexible Membership",
        },
      ],
    },
    {
      to: "#PremiumSeating",
      title: "Premium Seating",
      offset: -100,
      id: 5,
      trackingTitle: "Premium Seating",
      anchors: [
        {
          anchor: "#header",
          title: "Premium Seating",
        },
      ],
    },
    {
      to: "#CoreBenefits",
      title: "Season Member Benefits",
      offset: -100,
      id: 6,
      trackingTitle: "Season Member Benefits",
      anchors: [
        {
          anchor: "#header",
          title: "Season Member Benefits",
        },
      ],
    },
    {
      to: "#GiftOption",
      title: "Gift Options",
      offset: -100,
      id: 7,
      trackingTitle: "Gift Options",
      anchors: [
        {
          anchor: "#header",
          title: "Gift Options",
        },
      ],
    },
    {
      to: "#PartyAreas",
      title: "Party Areas",
      offset: -100,
      id: 8,
      trackingTitle: "Party Areas",
      anchors: [
        {
          anchor: "#header",
          title: "Party Areas",
        },
      ],
    },
    {
      to: "#SingleGameSuites",
      title: "Single Game Suites",
      offset: -100,
      id: 9,
      trackingTitle: "Single Game Suites",
      anchors: [
        {
          anchor: "#header",
          title: "Single Game Suites",
        },
      ],
    },
    {
      to: "#LouisianaLedge",
      title: "Viva Victory Ledge",
      offset: -100,
      id: 10,
      trackingTitle: "Left Field Ledge",
      anchors: [
        {
          anchor: "#header",
          title: "Left Field Ledge",
        },
      ],
    },
    {
      to: "#Schedule",
      title: "Schedule",
      offset: 50,
      id: 11,
      trackingTitle: "Schedule",
      anchors: [
        {
          anchor: "#header",
          title: "Seating & Pricing",
        },
      ],
    },
    {
      to: "#Faq",
      title: "Frequently Asked Questions",
      offset: -100,
      id: 12,
      trackingTitle: "Frequently Asked Questions",
      anchors: [
        {
          anchor: "#header",
          title: "Frequently Asked Questions",
        },
      ],
    },
    {
      to: "#Summary",
      title:
        store.getters.getSummary.length < 1
          ? "Summary"
          : store.getters.getSummary[0].title,
      offset: -100,
      id: 13,
      trackingTitle: "Summary",
      anchors: [
        {
          anchor: "#header",
          title: "Summary",
        },
      ],
    },
  ];
  return {
    primaryLinks,
  };
};
